import { DataService } from '../../utils/dataService'
import { error } from '../../notifications/displayMessage'
import { AxiosResponse } from 'axios'
import { datadogLogs } from '@datadog/browser-logs'

export const SEARCH_CATEGORIES_DETAIL = 'SEARCH_CATEGORIES_DETAIL'
export const SHOW_LOADING_CATEGORIES_DETAIL = 'SHOW_LOADING_CATEGORIES_DETAIL'
export const HIDE_LOADING_CATEGORIES_DETAIL = 'HIDE_LOADING_CATEGORIES_DETAIL'
export const CLEAN_CATEGORIES_DETAIL = 'CLEAN_CATEGORIES_DETAIL'
export const SET_CATEGORY_NAME = 'SET_CATEGORY_NAME'

export const callCategoriesDetail = (path: string, filter: any, manage: number = 0) => async(dispatch : any) => {
    filter.filter.manage = manage
    const _dataService = new DataService()
    await _dataService
        .postElastic('/catalogue/products', null, filter)
        .then((res: AxiosResponse) => {
            
            if (res.status === 200) {
                dispatch({
                    type: SEARCH_CATEGORIES_DETAIL,
                    payload: res.data
                })
            } 
        })
        .catch((err) => {
          error(`Ha ocurrido un error `)
          datadogLogs.logger.info('error request callCategoriesDetail', { name: 'post /catalogue/products', body: filter, error: err.message })
        })
}

export const cleanCategoriesDetail = () => async(dispatch: any) => {
    dispatch({
        type: CLEAN_CATEGORIES_DETAIL
    })
}

export const loadingShowCategoriesDetail = () => async(dispatch: any) => {
    dispatch({
        type: SHOW_LOADING_CATEGORIES_DETAIL
    })
}

export const loadingHideCategoriesDetail = () => async(dispatch: any) => {
    dispatch({
        type: HIDE_LOADING_CATEGORIES_DETAIL
    })
}

export const setCategoryDetailName = (categoryName:any) => async(dispatch: any) => {
    dispatch({
        type: SET_CATEGORY_NAME,
        payload:categoryName
    })
}

